import type { SxProps, Theme } from '@mui/material';

export const styles = {
    root: (width: number | string = 200): SxProps<Theme> => ({
        '& .MuiOutlinedInput-root': {
            width,
            height: '32px',
            borderRadius: '8px',
            fontSize: '12px',
            fontWeight: 500,
            padding: '10px',
            color: 'grey.800',
        },
        '& .MuiOutlinedInput-input': {
            padding: 0,
        },
    }),
    icon: (theme: Theme) => ({ color: theme.palette.blue.main, mr: 1 }),
};
